import { combineReducers } from 'redux';
import { getCoreDataSecurityMonitorsSlice } from './get';
import { postCoreDataSecurityMonitorsSlice } from './post';
import { removeCoreDataSecurityMonitorsSyncSlice } from './remove';
import { updateCoreDataSecurityMonitorsSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { coreDataSecurityMonitorsAllReducers, coreDataSecurityMonitorsAllWatchers } from './all';
import { coreDataSecurityMonitorsByApplicationReducers, coreDataSecurityMonitorsByApplicationWatchers } from './application';
import { coreDataSecurityMonitorsByIdReducers, coreDataSecurityMonitorsByIdWatchers } from './_id';

export const coreDataSecurityMonitorsReducers = combineReducers({
	all: coreDataSecurityMonitorsAllReducers,
	application: coreDataSecurityMonitorsByApplicationReducers,
	byId: coreDataSecurityMonitorsByIdReducers,
	get: joinReducers([
		getCoreDataSecurityMonitorsSlice.asyncReducers,
		removeCoreDataSecurityMonitorsSyncSlice.syncReducer,
		updateCoreDataSecurityMonitorsSyncSlice.syncReducer
	], getCoreDataSecurityMonitorsSlice.asyncState),
	post: postCoreDataSecurityMonitorsSlice.asyncReducers
});

export const coreDataSecurityMonitorsWatchers = combineAllWatchers([
	coreDataSecurityMonitorsAllWatchers,
	coreDataSecurityMonitorsByIdWatchers,
	coreDataSecurityMonitorsByApplicationWatchers,
	getCoreDataSecurityMonitorsSlice.asyncWatchers,
	postCoreDataSecurityMonitorsSlice.asyncWatchers
]);
